const initialState = {
    agentBrokerPermissionsView:{},
    agentBrokerListsView: [],
    agentBrokerHighlightedRecordView: null,
    agentBrokerListsIDView:[],
    agentBrokerStatusView: [],
    changedAgentBrokerStatusView : [],
    loadingAgentBrokerView: false,
    errorsAgentBrokerView: {},
    updateIdView:"",
    agentBrokerCountView: 0,
}

const  agentBrokerReducerView = (state = initialState, action) => {
    switch (action.type) {
        case "GET_AGENTBROKERLIST_PENDING_VIEW":
        case "ADD_AGENTBROKER_PENDING_VIEW":
        case "UPDATE_AGENTBROKER_PENDING_VIEW":
        case "UPDATE_AGENTBROKER_STATUS_PENDING_VIEW":
        case "DELETE_AGENTBROKER_PENDING_VIEW":
        case "GET_AGENTBROKERLISTBYID_PENDING_VIEW":
            return { ...state, loadingAgentBrokerView: true , errorsAgentBrokerView:{}};

        case "GET_AGENTBROKERLIST_FULFILLED_VIEW":
            return {
                ...state,
                loadingAgentBrokerView: false,
                agentBrokerListsView: action.payload,
                agentBrokerCountView: action.count,
                agentBrokerPermissionsView:action.permissions,
            };

        case "ADD_AGENTBROKER_FULFILLED_VIEW":
            return {
                ...state,
                loadingAgentBrokerView: false,
                changedAgentBrokerStatusView: action.payload,
                updateIdView:action.payload?.data?.id  || state.updateIdView,
                errorsAgentBrokerView:{}
                
            };

        case "UPDATE_AGENTBROKER_FULFILLED_VIEW":
            return {
                ...state,
                loadingAgentBrokerView: false,
                changedAgentBrokerStatusView: action.payload,
                updateIdView:action.payload?.data?.id || state.updateIdView,
                errorsAgentBrokerView:{},
            };

        case "UPDATE_AGENTBROKER_STATUS_FULFILLED_VIEW":
            return {
                ...state,
                loadingAgentBrokerView: false,
                changedAgentBrokerStatusView: action.payload,
            };

        case "GET_AGENTBROKERLISTBYID_FULFILLED_VIEW":
            return {
                ...state,
                loadingAgentBrokerView: false,
                agentBrokerListsIDView: action.payload,
            };

        case "DELETE_AGENTBROKER_FULFILLED_VIEW":
            return {
                ...state,
                loadingAgentBrokerView: false,
                changedAgentBrokerStatusView: action.payload
            };

        case "RESET_DELETE_AGENTBROKER_STATUS_VIEW":
            return {
                ...state,
                loadingAgentBrokerView: false,
                changedAgentBrokerStatusView: [],
                errorsAgentBrokerView:{}
            };

        case "GET_AGENTBROKERLIST_REJECTED_VIEW":
        case "ADD_AGENTBROKER_REJECTED_VIEW":
        case "UPDATE_AGENTBROKER_REJECTED_VIEW":
        case "UPDATE_AGENTBROKER_STATUS_REJECTED_VIEW":
        case "DELETE_AGENTBROKER_REJECTED_VIEW":
        case "GET_AGENTBROKERLISTBYID_REJECTED_VIEW":
            return {
                ...state,
                loadingAgentBrokerView: false,
                errorsAgentBrokerView: action.payload
            };
        case "SET_AGENTBROKER_HIGHLIGHTED_RECORD_VIEW":
            return { 
                ...state, 
                agentBrokerHighlightedRecordView: action.payload 
            };
        case "CLEAR_AGENTBROKER_HIGHLIGHTED_RECORD_VIEW":
            return { 
                ...state, 
                agentBrokerHighlightedRecordView: null 
            };

        default:
            return state;
    }
}

export default agentBrokerReducerView;